/* =========================================================================
   gloofy — enhance.js
   Additive Animations-Schicht. Greift NICHT in bestehende Logik ein.
   - Scroll-Reveals via IntersectionObserver
   - Klick-/Tap-Pop-Feedback
   - Warenkorb-Badge-Bump bei Mengenänderung
   - Weiches Einblenden von Bildern
   Respektiert prefers-reduced-motion vollständig.
   ========================================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     1 · Reveal-Ziele automatisch markieren (ohne Markup zu ändern)
     --------------------------------------------------------------------- */
  function tagReveals() {
    // Sektions-Überschriften
    document.querySelectorAll('.section-head').forEach(function (el) {
      el.classList.add('reveal');
    });

    // Container, deren Kinder gestaffelt aufploppen sollen
    // Container, deren Kinder gestaffelt aufploppen sollen.
    // Bewusst OHNE die horizontal scrollenden Rails (.rail, .community__rail),
    // damit deren Touch-Scrolling absolut flüssig bleibt.
    var staggerSelectors = [
      '.benefits__grid',
      '.reviews__grid',
      '.notes__grid',
      '.how__steps',
      '.bundle__grid',
      '.usp',
      '.assure'
    ];
    staggerSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add('reveal', 'reveal-stagger');
      });
    });

    // Einzelne größere Blöcke, die als Ganzes einschweben
    var blockSelectors = [
      '.bundle__card',
      '.newsletter__card',
      '.trust',
      '.faq',
      '.how',
      '.notes',
      '.reviews',
      '.community',
      '.benefits'
    ];
    blockSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        // nicht doppelt taggen, wenn schon ein Stagger-Container
        if (!el.classList.contains('reveal-stagger')) {
          el.classList.add('reveal');
        }
      });
    });
  }

  /* ---------------------------------------------------------------------
     2 · IntersectionObserver schaltet .is-in
     --------------------------------------------------------------------- */
  function observeReveals() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------------
     3 · Tap-Pop-Feedback auf Buttons & klickbaren Elementen
     --------------------------------------------------------------------- */
  function wireTapPop() {
    if (reduce) return;
    var sel = '.btn, .add, .sw, .gthumb, .upsell__btn, .qtybox button, .ci__qty button';
    document.addEventListener('click', function (e) {
      var t = e.target.closest(sel);
      if (!t) return;
      t.classList.remove('tap-pop');
      // reflow, damit die Animation erneut startet
      void t.offsetWidth;
      t.classList.add('tap-pop');
      setTimeout(function () { t.classList.remove('tap-pop'); }, 450);
    }, { passive: true });
  }

  /* ---------------------------------------------------------------------
     4 · Warenkorb-Badge hüpft, wenn sich der Zähler ändert
     --------------------------------------------------------------------- */
  function watchCartCount() {
    if (reduce) return;
    var badge = document.getElementById('cart-count');
    if (!badge || !('MutationObserver' in window)) return;

    var last = badge.textContent;
    var mo = new MutationObserver(function () {
      if (badge.textContent !== last) {
        last = badge.textContent;
        badge.classList.remove('bump');
        void badge.offsetWidth;
        badge.classList.add('bump');
      }
    });
    mo.observe(badge, { childList: true, characterData: true, subtree: true });
  }

  /* ---------------------------------------------------------------------
     5 · Bilder weich einblenden, sobald geladen
     --------------------------------------------------------------------- */
  function fadeInImages() {
    if (reduce) return;
    document.querySelectorAll('img').forEach(function (img) {
      // Galerie-Bilder NICHT anfassen — deren Sichtbarkeit/Swap steuert script.js.
      if (img.closest('.gallery, #gallery-main, .card__media')) return;
      // Schon geladene oder ohne echte Quelle überspringen
      if ((img.complete && img.naturalWidth > 0) || !img.getAttribute('src')) return;

      img.style.opacity = '0';
      var shown = false;
      var show = function () {
        if (shown) return;
        shown = true;
        img.style.opacity = '1';
      };
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', show, { once: true });
      // Sicherheitsnetz: falls load/error nie feuert (Cache, lazy, decode-Timing),
      // wird das Bild nach kurzer Zeit garantiert sichtbar gemacht.
      setTimeout(show, 1200);
      // Falls das Bild zwischen Check und jetzt fertig wurde:
      if (img.complete && img.naturalWidth > 0) show();
    });
  }

  /* ---------------------------------------------------------------------
     Init — auch bei Shopify-Theme-Editor-Neuladevorgängen robust
     --------------------------------------------------------------------- */
  function init() {
    tagReveals();
    observeReveals();
    wireTapPop();
    watchCartCount();
    fadeInImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Section-Rendering (Theme-Editor): neue Inhalte erneut taggen
  document.addEventListener('shopify:section:load', function () {
    tagReveals();
    observeReveals();
    fadeInImages();
  });
})();
